import { configureStore } from '@reduxjs/toolkit';
import { calendarReducers } from '@tecma/module-calendar';

import { sliceEnvironment } from './slice/slice.environment';
import { sliceI18n } from './slice/slice.i18n';

export const reduxStore = configureStore({
  reducer: {
    ...calendarReducers,
    environment: sliceEnvironment.reducer,
    i18n: sliceI18n.reducer,
  },
});
